import * as React from "react";
import { cn } from "@/lib/utils";

/**
 * The HosterDash logo. Renders the real logo image and falls back to the text
 * wordmark if the image is missing — so the app looks right whether or not the
 * file has been dropped in yet.
 *
 * Drop your logo at:  Frontend/public/brand/hosterdash-logo.png  (or .svg)
 * (Vite serves /public at the site root, so it's reachable at /brand/...)
 * Pass `src` to use a different file (e.g. a white variant on dark backgrounds).
 */
export function BrandLogo({
  src = "/brand/hosterdash-logo.jpg",
  className,
  alt = "HosterDash"
}: {
  src?: string;
  className?: string;
  alt?: string;
}) {
  const [failed, setFailed] = React.useState(false);

  if (failed) {
    return (
      <span className="font-display text-lg font-extrabold tracking-tight">
        Hoster<span className="text-brand-accent">Dash</span>
      </span>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      className={cn("h-8 w-auto select-none", className)}
      onError={() => setFailed(true)}
      draggable={false}
    />
  );
}
